/* ============================================================
   PRODUKTYVUMO PIRAMIDĖS TESTAS – logika + render
   Sluoksniai (silpniausia grandis = žemiausias suskilęs):
   1 energija · 2 ribos · 3 nuostatos · 4 struktūra · 5 strategija
   Skilimo taisyklė: 2-klausimių sluoksniai (1–4) suskyla, kai ABU ❌.
   Sluoksnis 5 (1 klausimas) suskyla nuo 1 ❌.
   Rezultatas: žemiausias suskilęs.
   Rezultatas siunčiamas į MailerLite (AJAX -> sv_pyramid_quiz_subscribe).
   ============================================================ */

const LAYERS = {
	1: { key: 'energija', name: 'energija ir poilsis' },
	2: { key: 'ribos', name: 'ribos' },
	3: { key: 'nuostatos', name: 'nuostatos' },
	4: { key: 'struktura', name: 'struktūra ir fokusas' },
	5: { key: 'strategija', name: 'strateginis darbas' },
};

// ---- bendras piramidės generatorius ----
// weakL: 1..5 = silpniausias (coral); null = įžanga (viskas spalvota); 'allsolid' = viskas tvirta
function buildPyramid(weakL) {
	const order = [5, 4, 3, 2, 1]; // viršus -> apačia
	return order
		.map((L) => {
			let cls;
			if (weakL === null) {
				// įžanga: visi spalvoti pagal poziciją
				cls = 'solid' + L;
			} else if (weakL === 'allsolid') {
				// stiprus visuose: visi spalvoti
				cls = 'solid' + L;
			} else if (L === weakL) {
				// silpniausias
				cls = 'weak';
			} else if (L < weakL) {
				// žemiau silpniausio = tvirta
				cls = 'solid' + L;
			} else {
				// virš silpniausio = nepasiekta
				cls = 'locked';
			}
			return `<div class="layer L${L} ${cls}">${LAYERS[L].name}</div>`;
		})
		.join('');
}

const QUESTIONS = [
	{
		id: 'Q1',
		layer: 1,
		q: 'ar dažniausiai išsimiegi ir keliesi tikrai pailsėjęs:usi?',
		yes: 'taip, dažniausiai ryte jaučiu, kad puikiai pailsėjau',
		no: 'ne, dažnai jaučiuosi pavargęs:usi net po miego',
		pickers: [
			'vakare niekaip neatsijungiu, galvoj sukasi darbai',
			'iki pat miego lindžiu ekranuose',
			'jau prabundu pavargęs:usi, net jei miegojau užtektinai valandų',
			'neturiu pastovaus miego ritmo',
			'po darbo nieko nebenoriu, tik paskrolint. net poilsiui nebelieka jėgų',
		],
	},

	{
		id: 'Q2',
		layer: 1,
		q: 'ar poilsis tau atrodo tiek pat svarbus, kiek darbas?',
		yes: 'taip, poilsis man - būtinybė, o ne premija už nuopelnus',
		no: 'kai ilsiuosi - jaučiu kaltę, lyg tinginiaučiau',
		pickers: [
			'kai ilsiuosi, jaučiuosi, lyg švaistyčiau laiką',
			'poilsį turiu „nusipelnyti", kitaip graužia kaltė',
			'sunku ilsėtis, kol yra nebaigtų darbų',
			'net atsipalaidavus įtampa kažkur viduj nedingsta',
		],
	},

	{
		id: 'Q3',
		layer: 2,
		branch: true,
		q: 'ar jauti, kad kontroliuoji savo darbo valandas?',
		yes: 'taip, turiu aiškią darbo pabaigą ir pradžią',
		no: 'ne, darbas užima tiek laiko, kiek tik leidžiu',
		pickersByRole: {
			A: [
				'per daug sprendimų turi eiti per mane',
				'viskas atrodo skubu ir svarbu',
				'neturiu kam deleguot, arba sunku paleist',
			],
			B: [
				'vis dar darau viską pats:i',
				'dirbu dinamiškai, kada randu laiko',
				'visada lieka dar kažkas, ką „dar reikia padaryt"',
			],
			C: [
				'per daug užduočių ar skubos iš vadovų',
				'nuolat trukdo kolegos ar klientai',
				'bijau sustot, kad nepasirodyčiau nepakankamai darbšti:us',
			],
		},
	},

	{
		id: 'Q4',
		layer: 2,
		q: 'ar gali atsijungt nuo darbo, kai nori – ne tik fiziškai, bet ir galvoj?',
		yes: 'taip, baigus darbą, apie darbus nebegalvoju',
		no: 'net jei nedirbu, mintimis vis tiek esu darbe',
		pickers: [
			'namai = darbas, viskas susilieja į vieną',
			'net laisvalaikiu mintys grįžta prie darbų',
			'jaučiu spaudimą būt pasiekiamas:a ir po darbo',
			'atrodo, viskas grius, jei atsitrauksiu nuo darbų',
		],
	},

	{
		id: 'Q5',
		layer: 3,
		q: 'ar gali ilsėtis be kaltės – net kai reikalų sąrašas dar nebaigtas?',
		yes: 'taip, nebaigtas sąrašas manęs nestabdo nuo poilsio',
		no: 'ne. vis atrodo, kad galėjau padaryt daugiau',
		pickers: [
			'visada jaučiu, kad galėjau daugiau',
			'atsipalaidavimas man = laiko švaistymas',
			'bijau praleist gerą progą, jei stabtelsiu',
			'net sąmoningai norėdamas:a neišsijungiu',
		],
	},

	{
		id: 'Q6',
		layer: 3,
		q: 'kai turi laiko ir reikia imtis svarbaus, bet nemalonaus ar gąsdinančio darbo – ar jo imiesi lengvai?',
		yes: 'taip, dažniausiai tiesiog pradedu, nepriklausomai nuo baimės ar nepatogumo',
		no: 'ne, dažniau randu svarbesnių darbų, arba atidėlioju, kol jau padai svyla',
		pickers: [
			'ilgai galvoju prieš pradėdamas:a, nenoriu suklyst',
			'noriu pasiruošt 100% ir nedaryt bet kaip, todėl atidėlioju',
			'net turėdamas:a laiko niekaip nepradedu, kol terminai nespaudžia',
			'svarbūs darbai atrodo sunkūs, lengviau imti ir padaryt smulkesnius',
			'kartais atrodo, kad tai, ką darau, neturi prasmės',
		],
	},

	{
		id: 'Q7',
		layer: 4,
		q: 'ar planavimas tau realiai padeda – ar dažniau tampa našta?',
		hint: 'ne „ar planuoji" (beveik visi planuojam). ar tas planas tau išties padeda?',
		yes: 'padeda, turiu sau veikiančią tvarką',
		no: 'planavimas man - veikiau našta. arba neplanuoju, nes neapsimoka',
		pickers: [
			'planavimas man dar vienas darbas, ne pagalba',
			'bandžiau, bet nematau prasmės, kai vis tiek viskas keičiasi',
			'prisiplanuoju, bet tada gyvenimui nebelieka vietos',
			'planavimas slopina laisvę ir kūrybiškumą, riboja',
			'nežinau, nuo ko išvis pradėt, kai visko tiek daug',
		],
	},

	{
		id: 'Q8',
		layer: 4,
		q: 'ar lengvai susigaudai savo užduotyse, projektuose, įrankiuose?',
		yes: 'taip, žinau, kur kas ir ko pirmiausiai imtis',
		no: 'ne, dažnai pasimetu pats:i savo sistemoj (arba jos nebuvime)',
		pickers: [
			'labai daug sąrašų ir įrankių, nežinau, nuo kurio pradėt',
			'vienu metu vykdau per daug projektų',
			'pradedu daug, užbaigiu mažai',
			'vis ieškau tobulos sistemos, todėl ir nepradedu',
			'kai bandau susitvarkyt, pasimetu dar labiau',
		],
	},

	{
		id: 'Q9',
		layer: 5,
		branch: true,
		q: 'ar turi laiko svarbiausiam – ne tik skubiems gaisrams gesint?',
		yes: 'taip, svarbiausi darbai gauna laiką ir vietą',
		no: 'ne, diena praeina gesinant, svarbiausi dažnai lieka tam laikui, kai laiko bus daugiau',
		pickersByRole: {
			A: [
				'komanda užverčia įvairiausio plauko klausimais',
				'niekaip neatsitraukiu nuo kasdienio darbų srauto',
				'nežinau, nuo ko išvis pradėt strateginį planavimą',
			],
			B: [
				'visas laikas atitenka užsakymams ar klientams',
				'atidėlioju svarbius, bet neskubius darbus, nes vis prireikia padaryti ką nors skubaus',
				'nėra aiškaus plano, ką ir kaip auginti ir kas būtų tie svarbūs darbai',
			],
			C: [
				'per dieną nesuspėju nieko tikrai reikšmingo',
				'viskas trukdo susikaupt strateginiam darbui',
				'gaunu tik gaisrus, ne laiką idėjoms ar strategijai',
			],
		},
	},
];

// ---- RESULT CONTENT (santrauka rezultato puslapiui; pilni tekstai – PDF/laiškuose) ----
// produktų kortelės (nemokamos / mokamos) ateina iš admin puslapio „Piramidės testo
// produktai" (includes/ppq-cards.php) per data-cards atributą, žr. boot apačioje.
const RESULTS = {
	energija: {
		title: 'energija ir poilsis',
		recog: 'jei skaitydamas:a klausimus apie energiją ir poilsį pritariamai linksėjai – tikriausiai ir be mano pasakymo jauti, kad čia greičiausiai ir bus pakastas tavo produktyvumo šuo (brrr, na ir posakis). ir papildoma motyvacija, paspardymas į sėdimąją arba geresnė planavimo sistema situacijos iš esmės nepakeis. jei tavo bakas dažniau tuščias nei pilnas, toli nenuvažiuosi (kad ir kaip gerai mokėtum vairuot)',
		why: 'energija – produktyvumo pamatas. viskas, kas aukščiau (ribos, planavimas, strateginiai darbai) naudoja energiją kaip kurą. jei energijos chroniškai trūksta, bet koks „tiesiog išmok geriau planuoti" patarimas subyra dar nepradėjus jo taikyti. bėda tame, kad čia dauguma griebiasi to, kas pridengia simptomus, bet nesprendžia priežasčių – perka naują planuoklį, kai iš tikro reikia tiesiog atsigaut ir išmokti savo baką papildyti reguliariai, kol dar nestovi vidury laukų su raudonai mirksinčia lempute.',
		rec: 'artimiausią savaitę vienintelis darbas – pažiūrėt į energiją kaip į resursą, ne kaip į savaime suprantamą dalyką, kuris atsiranda iš niekur. kada dienoj jautiesi gyviausia:s? kas siurbia tavo energiją be reikalo? sprendimų jokių dar nereikia – svarbu pirmiau pastebėti. nes kol nematai, kur energija dingsta – nelabai yra ką valdyt.',
		step: 'dienos pabaigoje pasižymėk vieną dalyką – kelintą valandą šiandien pajutai didžiausią nuovargį. ir jei šitą paprastą veiksmą pakartosi bent savaitę, pamatysi tendencijas (ir jau turėsi nuo ko atsispirt).',
	},
	ribos: {
		title: 'ribos',
		recog: 'energija tavo produktyvumą palaiko visai neblogai. bet darbas vis tiek įkiša nosį visur, kur tik gali – į vakarus, į savaitgalius, į galvą tada, kai turėtum ilsėtis. skamba pažįstamai? visiems randi laiko, tik ne sau, o tavo pačios:ties darbai amžinai paskutinėj vietoj. ir čia ne charakterio bėda ar „tiesiog toks gyvenimo etapas" – čia ribų klausimas.',
		why: 'ribos – antras produktyvumo sluoksnis, iškart virš energijos. ir logika čia labai paprasta: kol ribų nėra, energijos normaliam produktyvumui irgi niekada nebus, nes ją vis kažkas „pasiskolins" (ir, žinoma, negrąžins ;) ). gali prisiplanuot puikiausių dalykų, bet jei tavo dienotvarkę diktuoja kitų žmonių pageidavimai, tai gražus planas ir liks gražus …popieriuje. prieš imantis dėliotis planavimo sistemas, pirmiausia reikia atsiimti vairą į savo rankas. ribos ir yra tas vairas.',
		rec: 'tikrai ne nuo griežtų taisyklių visam gyvenimui. pradžiai užtenka vieno aiškaus „čia – mano laikas". bent pusvalandis dienoj, kuris yra TAVO ir kurio negali užimti niekas kitas. skamba kaip labai mažai? būtent todėl ir veikia – tokią ribą įmanoma realiai išlaikyt. o visi tie dideli ir gražūs „nuo pirmadienio viskas bus kitaip" dažniausiai griūva dar tą pačią dieną :D',
		step: 'rytoj rezervuok 30 minučių sau. savo svarbiems darbams ar tiesiog sau, ne kažkieno reikalams. įsirašyk į kalendorių kaip susitikimą (su savimi!) ir gerbk jį taip, kaip gerbtum susitikimą su kitu žmogum. juk neatšauksi susitikimo paskutinę minutę, ane? ;)',
	},
	nuostatos: {
		title: 'nuostatos',
		recog: 'iš išorės gali atrodyt, kad viskas tvarkoj – energijos užtenka, ribas sėkmingai brėži. o galvoj non stop sukasi užsikirtusi plokštelė: kaltė, kai ilsiesi. jausmas, kad galėjai padaryt daugiau. tas vidinis balsas, kuris niekada nepasako „užteks, gerai padarei". ir tai, tiesą sakant, sunkiausiai pastebima vieta iš visų – nes iš išorės jos nesimato niekam.',
		why: 'nuostatos – labai svarbus ir nepelnytai pamirštas produktyvumo sluoksnis. jokiam grafike ar kalendoriuj jo nematyti. gali turėt energijos, ribas, net visai gerą planą – bet jei kiekvieną žingsnį lydi „dar negana", joks planavimas neatneš ramybės, kuri apima, kai žinai, kad padarei užtektinai. ir čia jokie planuokliai nepadės (kad ir kokie gražūs ;)). sprendimas slepiasi visai kitur – tame, kaip kalbiesi su savimi. žinau iš praktikos, kad pakeisti tą užsikirtusią plokštelę nelengva, bet tikrai įmanoma.',
		rec: 'jei bandysi kovoti su tuo vidiniu balsu, tai nuo to jis tik garsės. todėl geriausia pradėti nuo elementarios savistabos. kaskart, kai pagauni save galvojant „galėjau daugiau", stabtelk ir paklausk savęs: o kada yra gana? ar skiriasi, kas yra gana šiandien, šią savaitę, šį mėnesį? ar tas „gana" yra paremtas žmogiškomis galimybėmis, ar labiau iš mokslinės fantastikos srities?',
		step: 'šįvakar, prieš miegą, užsirašyk, ką šiandien padarei. ne sąrašą neatliktų darbų – o tai, kas atlikta. ir leisk sau prie to sąrašo sekundę stabtelt ir padėkot sau už tai. žinau, skamba kaip niekai, bet pabandyk ir pamatysi ;)',
	},
	struktura: {
		title: 'struktūra ir fokusas',
		recog: 'produktyvumo pamatas tvirtas: energijos yra, ribas turi ir brėži, nuostatos nespaudžia galvos. bet darbai vis tiek išsibarstę visur, kur tik įmanoma. susiplanuoji 17 dalykų, padarai 8, likusius perkeli rytojui (o rytoj – ta pati istorija, tik sąrašas dar ilgesnis). gali atrodyti, kad tiesiog nieko nespėji, kai tiesa kur kas paprastesnė – tavo dėmesys išsibarstęs tarp visų reikaliukų, o bendro vaizdo nematyt.',
		why: 'čia kalba pagaliau pasisuka apie patį planavimą. ir tai gera žinia: reiškia, produktyvumo pamatas tvirtai tave laiko ir galim ramiai statyt struktūrą, kuri turės į ką atsiremt. tik iškart pasakysiu: nepulsime visko žymėti spalvomis ir rūšiuoti. pradžiai reikia labai elementaraus, paprasto žingsnelio, kuris padės viską sudėti į vieną vietą.',
		rec: 'nuo radikalaus supaprastinimo. pasirink vieną vietą, kurioje laikysi visus reikalus. ir kai sakau „visus", turiu galvoje tikrai visus (taip, net ir tuos, kurie „nesiskaito"). gal skamba paprastai, bet kai vienoje vietoje prieš akis matai visus darbus ir įsipareigojimus, dingsta tas nuolatinis zvimbesys „kažką tikrai pamiršau".',
		step: 'šiandien surink VISKĄ į vieną vietą – visus sąrašus, lapelius ir mintis iš galvos – į vieną dokumentą ar sąsiuvinį. dar nieko netvarkyk, tiesiog sumesk į vieną vietą. ir pamatysi, kiek dėmesio suvalgydavo vien tai, kad mėgini ko nors nepamiršti ir nepraleisti.',
	},
	strategija: {
		title: 'strateginis darbas',
		recog: 'valio! turi tvirtą pagrindą – energija, ribos, nuostatos, net planavimo tvarka tiesiog blizga. bet kažkodėl vis tiek neapleidžia jausmas: diena praeina, daug ką nuveiki, o tie didieji, svarbieji darbai (kurie per laiką atneša didžiausius rezultatus) vis pasilieka rytojui. arba paskęsta gaisruose.',
		why: 'pirmiausia noriu atkreipti dėmesį: jei tavo silpniausia vieta čia, vadinasi, JAU padarei nemažą darbą. tai – retas atvejis. dauguma iki šito sluoksnio net neprieina, nes stringa žemiau. bet ir viršūnė turi savo spąstus. čia jau ne apie „daryti daugiau" (DAR DAUGIAU – mano nemėgstamiausias „produktyvumo" patarimas). čia turime kalbėti apie tai, kaip rasti laiko tam, kas svarbu. o skubu ir svarbu dažniausiai du labai skirtingi dalykai: skubūs darbai rėkia garsiausiai, todėl ir nustelbia tuos tylius, didelius, kurie iš tikro gali atvesti prie didesnių rezultatų.',
		rec: 'nuo erdvės, skirtos svarbiam darbui (apsaugotos nuo visokio plauko skubių reikalų). ne „rasiu laiko, kai bus ramesnis laikotarpis" (juk toks neateina niekada, ane? :D), o iš anksto rezervuotas langas strateginiam darbui per savaitę.',
		step: 'šią savaitę išsirink vieną darbą, kuris svarbus, bet nebūtinai skubus. rezervuok jam 90 minučių kalendoriuj ir saugok tą laiką taip, lyg tai būtų susitikimas su svarbiausiu klientu. nes, jei gerai pagalvoji – taip ir yra ;)',
	},
	stiprus_visuose: {
		title: 'stipri:us visuose lygiuose',
		recog: 'oho – tu stipri:us visuose lygiuose. energija, ribos, nuostatos, struktūra, strateginis darbas: viskas savo vietoj ir savu laiku. ir tai ne atsitiktinumas – nors kitiems gali atrodyti, kad tau savaime gaunasi, tie dalykai neatsiranda be pastangų ir atkaklumo.',
		why: 'tavo klausimas dabar kitoks: jau ne „ką taisyt", o „kaip su tuo elgtis toliau". matau du kelius, kurie puikiai dera kartu – išlaikyti (kad sistema atlaikytų, kai gyvenimas viską supurtys, o jis supurto) ir šlifuoti (kad tai, kas jau veikia, reikalautų dar mažiau pastangų).',
		rec: 'pirma – tiesiog pasidžiauk tuo, ką turi. tik neįsivelk į amžiną tobulinimosi ratuką (kai viskas gerai, lengva pradėt ieškot, ką dar „patobulint", ir prarast tai, kas veikia). o tada ramiai gali pažiūrėt į vieną vietą, kur galėtum sau palengvint – padaryt kažką greičiau ar su mažiau pastangų.',
		step: 'pasižymėk vieną darbą, kuris užtrunka gana ilgai ir (arba) kurį ne itin mėgsti. užrašyk bent 5 idėjas, kaip galėtum jį padaryti greičiau ar mažiau kankinantis. paprašyk DI, kad pasiūlytų, kaip optimizuoti. paklausk kitų žmonių. štai – turi idėjų, kur gali nukreipti savo dėmesį per artimiausią mėnesį didinant savo produktyvumą;)',
	},
};

// ---------------- STATE ----------------
let state = { role: null, answers: {}, pickers: {}, idx: -1, weakKey: null, weakLayer: null };

const els = { screen: null, bar: null, counter: null };

// rezultatų kortelės iš admin nustatymų (užpildoma boot metu iš data-cards atributo)
let resultCards = {};

const totalSteps = QUESTIONS.length; // role shown separately (intro+role = step 0)

const ROLE_NAMES = { A: 'komanda', B: 'solo', C: 'samdoma' };
let statsStarted = false;

function setProgress() {
	let done = state.idx < 0 ? 0 : state.idx;
	let pct = Math.round((done / totalSteps) * 100);
	els.bar.style.width = pct + '%';
	if (state.idx >= 0 && state.idx < QUESTIONS.length) {
		els.counter.textContent = state.idx + 1 + ' / ' + totalSteps;
	} else {
		els.counter.textContent = '';
	}
}

// ---------------- RENDER: INTRO ----------------
function renderIntro() {
	state.idx = -2;
	setProgress();
	els.screen.innerHTML = `
   <div class="screen intro">
     <div class="pyramid intro-pyr">${buildPyramid(null)}</div>

     <p class="lead">aukščiau matai produktyvumo piramidę. kiekvienas jos sluoksnis remiasi į žemiau esančius, ir taip yra neatsitiktinai.</p>
     <p>produktyvumą – asmeninį, apimantį visą gyvenimą, o ne tik gamybinius vienetus per laiką – išmatuoti skaičiais beveik neįmanoma (dar ir dėl to, kad kiekvieno asmeninė produktyvumo formulė labai individuali, skiriasi priklausomai nuo tikslų ir pan). tačiau ką mes galime padaryti – nustatyti, kuriame sluoksnyje yra didžiausias potencialas pagerinti situaciją.</p>
     <p class="signoff">devyni paprasti klausimai. atsakinėk taip, kaip yra dabar – nes testas parodys tavo dabartinę situaciją ir pasiūlys, ką daryti, kad būtų bent truputį geriau.</p>
     <button class="btn full" onclick="svPPQ.renderRole()">pradėti →</button>
   </div>`;
}

// ---------------- RENDER: ROLE ----------------
function renderRole() {
	state.idx = -1;
	setProgress();
	const sel = state.role;
	els.screen.innerHTML = `
   <div class="screen">
     <p class="eyebrow">prieš pradedant</p>
     <p class="qtext">kas šiuo metu labiausiai atitinka tavo realią situaciją?</p>
     <div class="opts">
       ${roleOpt('A', 'turiu komandą ar dirbu su partneriais', sel)}
       ${roleOpt('B', 'dirbu vienas:a (solo)', sel)}
       ${roleOpt('C', 'dirbu pagal darbo sutartį (samdoma:s)', sel)}
     </div>
     <div class="navrow">
       <button class="btn ghost" onclick="svPPQ.renderIntro()">← atgal</button>
       <div class="spacer"></div>
       <button class="btn" id="ppq-role-next" ${sel ? '' : 'disabled'} onclick="svPPQ.startQuestions()">toliau →</button>
     </div>
   </div>`;
}
function roleOpt(val, label, sel) {
	return `<button class="opt ${sel === val ? 'sel' : ''}" onclick="svPPQ.pickRole('${val}')">
    <span class="dot"></span><span>${label}</span></button>`;
}
function pickRole(v) {
	state.role = v;
	renderRole();
}
function startQuestions() {
	if (!state.role) return;
	if (!statsStarted) {
		statsStarted = true;
		sendStats(['ppq_started']);
	}
	state.idx = 0;
	renderQuestion();
}

// ---------------- RENDER: QUESTION ----------------
function canProceed(Q) {
	const ans = state.answers[Q.id];
	if (!ans) return false; // reikia atsakymo
	if (ans === 'no') {
		// jei "ne" -> reikia bent vienos priežasties
		const chosen = state.pickers[Q.id] || [];
		if (chosen.length === 0) return false;
	}
	return true;
}
function renderQuestion() {
	setProgress();
	const Q = QUESTIONS[state.idx];
	const ans = state.answers[Q.id]; // 'yes' | 'no' | undefined
	const showPicker = ans === 'no';
	let pickerOpts = [];
	if (Q.branch) {
		pickerOpts = Q.pickersByRole[state.role] || [];
	} else {
		pickerOpts = Q.pickers || [];
	}

	els.screen.innerHTML = `
   <div class="screen">
     <p class="qnum">klausimas ${state.idx + 1} / ${totalSteps}</p>
     <p class="qtext">${Q.q}</p>
     ${Q.hint ? `<p class="qhint">${Q.hint}</p>` : ''}
     <div class="yn">
       <button class="opt ${ans === 'yes' ? 'sel' : ''}" onclick="svPPQ.answer('${Q.id}','yes')"><span class="dot"></span><span>${Q.yes}</span></button>
       <button class="opt ${ans === 'no' ? 'sel' : ''}" onclick="svPPQ.answer('${Q.id}','no')"><span class="dot"></span><span>${Q.no}</span></button>
     </div>
     <div id="ppq-picker-area">${showPicker ? renderPicker(Q, pickerOpts) : ''}</div>
     <div class="navrow">
       <button class="btn ghost" onclick="svPPQ.prevStep()">← atgal</button>
       <div class="spacer"></div>
       <button class="btn" id="ppq-next" ${canProceed(Q) ? '' : 'disabled'} onclick="svPPQ.nextStep()">${state.idx === QUESTIONS.length - 1 ? 'rezultatas →' : 'toliau →'}</button>
     </div>
   </div>`;
}
function renderPicker(Q, opts) {
	const chosen = state.pickers[Q.id] || [];
	let head = '';
	if (Q.branch) {
		const rl = { A: 'turiu komandą / partnerius', B: 'dirbu vienas:a (solo)', C: 'dirbu pagal darbo sutartį' }[state.role];
		head = `<p class="rolehdr">▸ ${rl}</p>`;
	}
	return `<div class="picker">
    <p class="plead">kurios priežastys tai nulemia? (gali žymėt kelias)</p>
    ${head}
    ${opts
		.map(
			(o, i) => `<button class="chk ${chosen.includes(i) ? 'sel' : ''}" onclick="svPPQ.togglePick('${Q.id}',${i})">
        <span class="box"></span><span>${o}</span></button>`,
		)
		.join('')}
  </div>`;
}
function answer(qid, val) {
	state.answers[qid] = val;
	if (val === 'yes') {
		delete state.pickers[qid];
	}
	renderQuestion();
}
function togglePick(qid, i) {
	const arr = state.pickers[qid] || [];
	const at = arr.indexOf(i);
	if (at >= 0) arr.splice(at, 1);
	else arr.push(i);
	state.pickers[qid] = arr;
	// re-render only picker + keep scroll
	const Q = QUESTIONS[state.idx];
	let opts = Q.branch ? Q.pickersByRole[state.role] : Q.pickers;
	document.getElementById('ppq-picker-area').innerHTML = renderPicker(Q, opts);
	// atnaujinti "toliau" mygtuko būseną
	const nb = document.getElementById('ppq-next');
	if (nb) nb.disabled = !canProceed(Q);
}
function prevStep() {
	if (state.idx === 0) {
		renderRole();
	} else {
		state.idx--;
		renderQuestion();
	}
}
function nextStep() {
	if (!state.answers[QUESTIONS[state.idx].id]) return;
	if (state.idx === QUESTIONS.length - 1) {
		computeResult();
		renderResult();
	} else {
		state.idx++;
		renderQuestion();
	}
}

// ---------------- REZULTATO IŠSAUGOJIMAS NARŠYKLĖJE ----------------
// kad netyčia išėjus iš puslapio nereikėtų testo daryti iš naujo
const STORAGE_KEY = 'svPPQResult';
const STORAGE_DAYS = 100;

function saveResult() {
	try {
		localStorage.setItem(
			STORAGE_KEY,
			JSON.stringify({
				v: 1,
				ts: Date.now(),
				role: state.role,
				answers: state.answers,
				pickers: state.pickers,
				weakKey: state.weakKey,
				weakLayer: state.weakLayer,
			}),
		);
	} catch (e) {
		/* localStorage nepasiekiamas (pvz. privatus režimas) – tiesiog nesaugom */
	}
}
function loadSavedResult() {
	try {
		const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
		if (!saved || saved.v !== 1 || !RESULTS[saved.weakKey]) return null;
		if (Date.now() - (saved.ts || 0) > STORAGE_DAYS * 24 * 60 * 60 * 1000) return null;
		return saved;
	} catch (e) {
		return null;
	}
}
function clearSavedResult() {
	try {
		localStorage.removeItem(STORAGE_KEY);
	} catch (e) {
		/* ignore */
	}
}

// ---------------- COMPUTE WEAK LAYER ----------------
function computeCracks() {
	// returns {1:bool,...} cracked per layer
	const cracks = {};
	for (let L = 1; L <= 5; L++) {
		const qs = QUESTIONS.filter((q) => q.layer === L);
		const nos = qs.filter((q) => state.answers[q.id] === 'no').length;
		if (L === 5) {
			cracks[L] = nos >= 1;
		} else {
			cracks[L] = nos >= 2;
		} // both questions ❌
	}
	return cracks;
}
function computeResult() {
	const cracks = computeCracks();
	// lowest cracked layer wins
	let weak = null;
	for (let L = 1; L <= 5; L++) {
		if (cracks[L]) {
			weak = L;
			break;
		}
	}
	if (weak === null) {
		state.weakKey = 'stiprus_visuose';
		state.weakLayer = null;
	} else {
		state.weakKey = LAYERS[weak].key;
		state.weakLayer = weak;
	}
	saveResult();
}

// ---------------- RENDER: RESULT ----------------
// fromRestore = rezultatas atkurtas iš localStorage: statistikos nebesiunčiam,
// kad pakartotiniai apsilankymai nedidintų "completed" skaitliukų
function renderResult(fromRestore) {
	setProgress();
	els.bar.style.width = '100%';
	els.counter.textContent = '';
	const key = state.weakKey;
	const R = RESULTS[key];
	const weakL = state.weakLayer; // 1..5 or null

	// pyramid: silpniausias coral, žemiau tvirta, virš jo pilka; stiprus visuose = viskas spalvota
	const pyr = buildPyramid(key === 'stiprus_visuose' ? 'allsolid' : weakL);

	const cards = resultCards[key] || {};
	const freeCards = (cards.free || []).map((c) => card(c, false)).join('');
	const paidCards = (cards.paid || []).map((c) => card(c, true)).join('');

	const introLead = 'tavo atsakymai rodo štai ką:';
	const intro = `
     <div class="rblock rintro">produktyvumas – kaip piramidė (nepainioti su piramidės schema, haha;D). apačioj – visa ko pagrindas: energija ir poilsis. virš jų – ribos, kurios padeda apsaugoti tavo reikalus nuo kitų žmonių interesų. dar aukščiau – nuostatos, kurios diktuoja, kiek ir ko sau leidi ir kiek iš savęs reikalauji. ir tik tada galime pradėti kalbėti apie planavimo struktūrą ir strategines užduotis, kurios atneša tuos labai saldžius rezultatus.</div>
     <div class="rblock rintro">o esmė šitos piramidės labai paprasta: kiekvienas sluoksnis remiasi į apatinį. gali turėti genialiausią planavimo sistemą (aš jų esu išbandžiusi daugiau nei norėčiau prisipažint :D), bet jei energija žemiau nulio arba neegzistuoja jokios ribos – tai planuok neplanavus. tiesiog suksiesi amžinam planuoju – gyvenimas – nesigauna – vėl planuoju rate. ir ne planavimo sistema čia bus dėl visko kalta (bet jau turbūt pagauni mano mintį;))</div>
     <div class="rblock rintro">tai jeigu kalbame apie produktyvumą, nereikia pradėt taisyt visko iš karto ir vienu metu. pirmiausia – pasižiūrime, kuris sluoksnis dabar silpniausias ir ką galima padaryti, kad jis sutvirtėtų. ${introLead}</div>`;
	els.screen.innerHTML = `
   <div class="screen result-body">
     ${intro}

     <div class="pyramid">${pyr}</div>

     <div class="rblock"><strong class="lab">kaip yra dabar</strong>${R.recog}</div>
     <div class="rblock"><strong class="lab">${key === 'stiprus_visuose' ? 'ką tai reiškia' : 'kodėl verta daryti pokytį būtent čia'}</strong>${R.why}</div>
     <div class="rblock"><strong class="lab">${key === 'stiprus_visuose' ? 'nuo ko verta pradėti, norint išlaikyti?' : 'nuo ko verta pradėti, norint pokyčio?'}</strong>${R.rec}</div>
     <div class="rblock"><strong class="lab">vienas žingsnis, kurį gali padaryti iškart</strong>${R.step}</div>

     <div class="ladderbox">
       <h3>gidas pokyčiui pasiekti mažais žingsneliais</h3>
       <p>${key === 'stiprus_visuose' ? 'nedidelis pasitikrinimo gidas, kaip tai, kas veikia, išlaikyti ir šlifuoti. parašyk, kur jį atsiųsti.' : 'gidas su penkiais nedideliais žingsneliais šitam sluoksniui sutvirtinti, savo tempu. parašyk, kur jį atsiųsti.'}</p>
       <div class="ml-embed" id="ppq-form-slot">
         <div class="form-fallback">
           <input type="email" id="ppq-email" placeholder="tavo el. paštas" autocomplete="email" inputmode="email" onkeydown="if(event.key==='Enter'){svPPQ.submitEmail();}" />
           <input type="text" id="ppq-hp" name="ppq_website" value="" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;height:0;width:0;opacity:0;" />
           <button class="btn full" id="ppq-submit" onclick="svPPQ.submitEmail()">atsiųsti man gidą →</button>
         </div>
       </div>
     </div>

     ${freeCards ? `<div class="cards-grp">
       <p class="gh">papildomi nemokami resursai</p>
       ${freeCards}
     </div>` : ''}
     ${paidCards ? `<div class="cards-grp">
       <p class="gh">rimtesniam darbui</p>
       ${paidCards}
     </div>` : ''}

     <div class="restart"><button onclick="svPPQ.restart()">perdaryti testą</button></div>
   </div>`;

	if (!fromRestore) {
		sendStats(completionStatKeys());
		// Meta Pixel: testas baigtas (tik tikras baigimas, ne atkurtas rezultatas)
		if (typeof fbq === 'function') fbq('trackCustom', 'TestasBaigtas');
	}
}
function card(c, paid) {
	// atsidaro naujam tab'e, kad neprarastų testo rezultato
	return `<a class="pcard ${paid ? 'paid' : ''}" href="${escapeHtml(c.u || '')}" target="_blank" rel="noopener">
    <div class="pt">${escapeHtml(c.t || '')}</div>
    <div class="pd">${escapeHtml(c.d || '')}</div>
    <div class="pgo">${paid ? 'sužinoti daugiau →' : 'atsidaryti →'}</div>
  </a>`;
}
// ---------------- STATS (anoniminiai skaitliukai) ----------------
function sendStats(keys) {
	if (typeof sv_ajax_object === 'undefined' || !keys.length) return;
	const d = new FormData();
	d.append('action', 'sv_ppq_stats');
	d.append('nonce', sv_ajax_object.nonce);
	keys.forEach((k) => d.append('stats[]', k));
	fetch(sv_ajax_object.ajax_url, { method: 'POST', body: d }).catch(() => {});
}
// kokie skaitliukai didinami pasiekus rezultatą: rezultatas, rolė, kiekvieno
// klausimo "ne" ir pažymėtos priežastys (1-based; Q3/Q9 – atskirai pagal rolę)
function completionStatKeys() {
	const keys = ['ppq_completed', 'ppq_result_' + state.weakKey.replace('_', '-')];
	if (ROLE_NAMES[state.role]) keys.push('ppq_role_' + ROLE_NAMES[state.role]);
	QUESTIONS.forEach((Q) => {
		if (state.answers[Q.id] !== 'no') return;
		keys.push('ppq_' + Q.id + '_ne');
		const mid = Q.branch ? Q.id + '_' + (ROLE_NAMES[state.role] || 'x') : Q.id;
		(state.pickers[Q.id] || []).forEach((i) => keys.push('ppq_' + mid + '_p' + (i + 1)));
	});
	return keys;
}
// kompaktiška atsakymų santrauka MailerLite laukui, pvz. Q1:ne[1,3]|Q2:taip|...
function answersSummary() {
	return QUESTIONS.map((Q) => {
		if (state.answers[Q.id] === 'no') {
			const picks = (state.pickers[Q.id] || [])
				.slice()
				.sort((a, b) => a - b)
				.map((i) => i + 1);
			return Q.id + ':ne' + (picks.length ? '[' + picks.join(',') + ']' : '');
		}
		return Q.id + ':taip';
	}).join('|');
}

// ---------------- SUBMIT -> MAILERLITE ----------------
function escapeHtml(s) {
	return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function submitEmail() {
	const emailEl = document.getElementById('ppq-email');
	const email = emailEl ? emailEl.value.trim() : '';
	if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
		alert('įrašyk el. paštą :)');
		return;
	}
	if (!state.weakKey) return;
	if (typeof sv_ajax_object === 'undefined') {
		alert('ups, kažkas nesuveikė. perkrauk puslapį ir pabandyk dar kartą.');
		return;
	}

	const btn = document.getElementById('ppq-submit');
	const btnLabel = btn.textContent;
	btn.disabled = true;
	btn.textContent = 'siunčiama…';

	const hp = document.getElementById('ppq-hp');
	const data = new FormData();
	data.append('action', 'sv_pyramid_quiz_subscribe');
	data.append('nonce', sv_ajax_object.nonce);
	data.append('email', email);
	data.append('result', state.weakKey.replace('_', '-')); // energija | ribos | nuostatos | struktura | strategija | stiprus-visuose
	data.append('role', ROLE_NAMES[state.role] || '');
	data.append('answers', answersSummary());
	data.append('hp', hp ? hp.value : '');

	fetch(sv_ajax_object.ajax_url, { method: 'POST', body: data })
		.then((r) => r.json())
		.then((res) => {
			if (res && res.success) {
				document.getElementById('ppq-form-slot').innerHTML =
					'<p style="color:var(--orange);font-weight:700;">ačiū! gidas jau keliauja į ' +
					escapeHtml(email) +
					' 📩</p>' +
					'<p class="privacy">jei per kelias minutes nerasi – žvilgtelk į šlamšto (spam) aplanką</p>';
				// Meta Pixel: tik po sėkmingo užsakymo į MailerLite
				if (typeof fbq === 'function') fbq('track', 'Lead');
			} else {
				btn.disabled = false;
				btn.textContent = btnLabel;
				alert('ups, nepavyko išsiųsti. pabandyk dar kartą :)');
			}
		})
		.catch(() => {
			btn.disabled = false;
			btn.textContent = btnLabel;
			alert('ups, nepavyko išsiųsti. pabandyk dar kartą :)');
		});
}

function restart() {
	state = { role: null, answers: {}, pickers: {}, idx: -1, weakKey: null, weakLayer: null };
	statsStarted = false;
	clearSavedResult();
	renderIntro();
}

// public API for inline onclick handlers
window.svPPQ = {
	renderIntro,
	renderRole,
	pickRole,
	startQuestions,
	answer,
	togglePick,
	prevStep,
	nextStep,
	restart,
	submitEmail,
};

// boot
document.addEventListener('DOMContentLoaded', function () {
	const root = document.getElementById('sv-pyramid-quiz');
	if (!root) return;
	els.screen = document.getElementById('ppq-screen');
	els.bar = document.getElementById('ppq-bar');
	els.counter = document.getElementById('ppq-counter');
	try {
		resultCards = JSON.parse(root.dataset.cards || '{}') || {};
	} catch (e) {
		resultCards = {};
	}
	const saved = loadSavedResult();
	if (saved) {
		state.role = saved.role || null;
		state.answers = saved.answers || {};
		state.pickers = saved.pickers || {};
		state.weakKey = saved.weakKey;
		state.weakLayer = saved.weakLayer;
		statsStarted = true;
		renderResult(true);
	} else {
		renderIntro();
	}
});
